import ExpandLessRounded from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  Icon,
  IconButton,
  Skeleton,
  Snackbar,
  Typography,
  Zoom,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Fragment, useEffect, useState } from "react";
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import { ReactComponent as DropFileSvg } from "../../../../assets/DropFile.svg";
import { connect } from "react-redux";
import { shadows } from "@mui/system";
import { docs_enum, getFileExtention } from "../../../../utils/helpers";
import { config_UPTIME } from "../../../../Constants";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { createGenericAttachment } from "../../../../actions/objects";
import mime from "mime";
import { makeStyles } from "tss-react/mui";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { Delete } from "@mui/icons-material";
import CardButton from "../../../../components/CardButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { getItem } from "../../../../utils/DataProtection";
import { Tooltip } from "antd";

export default connect(
  ({ i18n, machines }) => ({
    i18n,
    machines,
  }),
  {
    createGenericAttachment,
  }
)((props) => {
  const useStyles = makeStyles()((theme) => ({
    headlineSpacer: {
      marginTop: 38,
    },
    uploadedMediaContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      // marginBottom: 20
    },
    deleteButton: {
      display: "flex",
      alignItems: "flex-end",
      background: "none",
      border: "none",
      color: "gray",
      padding: 0,
    },
    mediaWrapper: {
      backgroundColor: "transparent",
      borderWidth: 0,
      padding: 0,
      boxShadow: "none",
      width: "214px",
      height: "139px",
      // height: 80,
      borderRadius: theme.roundness,
      overflow: "hidden",
      // marginRight: 16,

      "& img": {
        width: "100%",
        minHeight: "100%",
        height: "auto !important",
      },
    },
    videoPlayer: {
      borderRadius: theme.roundness,
      overflow: "hidden",
      marginRight: 16,
    },
    cardButtonLarge: {
      minWidth: 250,
      marginRight: 16,

      "& .mdi-icon, & .MuiSvgIcon-root": {
        ...theme.largeCardIcon,
      },
    },
    cardButton: {
      minWidth: 220,
      width: 332,
      height: 56,
      marginTop: 10,
    },
    pdfViewerButtons: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
  }));

  let itemId = props.item.id.replace(" ", "_");

  const i18n = props.i18n;

  const [expanded, setExpanded] = useState("");

  const [loading, setLoading] = useState("");

  const [hasInvalidFiles, setHasInvalidFiles] = useState([]);

  const { classes } = useStyles();
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setHasInvalidFiles([]);
  };

  const valedateDocument = (file) => {
    return file && file.type.length && docs_enum.includes(file.type);
  };

  const handleChangeDropFile = async (e) => {
    setLoading("dropzone-" + itemId);

    $("#dropzone-" + itemId).hide();
    $(`#${itemId}-header-summary`).css("background-color", "transparent");
    $(".docsDetails-" + itemId).show();

    const files = Array.from(e.target.files); // Handle multiple files
    if (files.length === 0) {
      return false;
    }

    let filesStatus = [];

    for (const file of files) {
      filesStatus.push({
        file: file,
        status: valedateDocument(file),
      });
    }

    let validFiles = filesStatus.filter((file) => {
      return file.status === true;
    });
    let invalidFiles = filesStatus.filter((file) => {
      return file.status === false;
    });

    if (invalidFiles.length) {
      setHasInvalidFiles(invalidFiles);
    }

    const user_token = getItem("user");
    const baseUrl = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
    };

    // Process each file
    for (const file of validFiles) {
      let targetFile = file.file;
      try {
        const exstention = getFileExtention(targetFile?.type);
        const nodeid = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();
        const exstension_payload = [{ nodeid: nodeid, extension: exstention }];

        // Step 1 - Call /files API for metadata
        const res = await axios.post(
          baseUrl,
          {
            count: 1,
            extensions: exstension_payload,
          },
          config
        );

        const uploadUrl = res.data[0].url;
        const fileid = res.data[0].fileid;
        const bucketid = res.data[0].bucketid;
        const FileVersion = res.data[0].fileversion;

        // Step 2 - Upload the file
        await axios.put(uploadUrl, targetFile, {
          headers: {
            "Content-Type": targetFile.type,
            "Access-Control-Allow-Origin": "*",
          },
        });

        // Step 3 - Create the attachment object
        const lang = "de";
        const attachment = {
          lang,
          description: "",
          file: {
            fileid: fileid,
            mimetype: targetFile.type,
            bucketid: bucketid,
            fileversion: FileVersion,
          },
          isattachmentof: props.machines.equipment.nodeid,
          specifier: props.item.id.replace("_", " "),
          title: targetFile.name.split(".")[0],
          nodeid,
        };

        // Dispatch Redux action to save attachment
        props.createGenericAttachment(attachment, "genericAttachment");
      } catch (error) {
        console.error(`Error uploading file: ${targetFile.name}`, error);
      }
    }

    // Update UI after processing files
    $("#dropzone-" + itemId).hide();
    $(`#${itemId}-header-summary`).css("background-color", "transparent");
    $(".docsDetails-" + itemId).show();
    setLoading("");
  };

  useEffect(() => {
    $("#dropzone-" + itemId).hide();

    var dragTimer;
    $(".docsWrapper-" + itemId).on("dragover", function(e) {
      $(".docsDetails-" + itemId).hide();
      var dt = e.originalEvent.dataTransfer;
      if (
        dt.types &&
        (dt.types.indexOf
          ? dt.types.indexOf("Files") != -1
          : dt.types.contains("Files"))
      ) {
        setExpanded(itemId);

        $("#dropzone-" + itemId).show();
        $(`#${itemId}-header-summary`).css("background-color", "#ECF0F1");
        window.clearTimeout(dragTimer);
      }
    });
    $(".docsWrapper-" + itemId).on("dragleave", function(e) {
      dragTimer = window.setTimeout(function() {
        setExpanded("");
        $("#dropzone-" + itemId).hide();
        $(`#${itemId}-header-summary`).css("background-color", "transparent");
        $(".docsDetails-" + itemId).show();
      }, 25);
    });
  }, []);

  let attachmentsByCategory = props.machines.equipment.hasattachment
    ? props.machines.equipment.hasattachment.filter((attachment) => {
        return attachment.attachment.specifier === props.item.id;
      })
    : [];

    let internal_specifier_attachments =props.machines.equipment.hasattachment
    ? props.machines.equipment.hasattachment.filter((attachment) => {
        return attachment.attachment.specifier === "internal attachment";
      })
    : [];


    if(props.item.id === "internalinstructions" && internal_specifier_attachments.length){
      attachmentsByCategory = [...attachmentsByCategory, ...internal_specifier_attachments];
    }

  return (
    <div className={"docsWrapper-" + itemId} style={{ width: "100%" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={hasInvalidFiles.length}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        TransitionComponent={Zoom}
      >
        <Alert severity={"error"} sx={{ width: "100%" }} className="bxShadow">
          <Tooltip
            zIndex={11111}
            title={
              <div>
                {" "}
                Es sind nur (Text, PDF, Word, Excel) Dateien zulässig!{" "}
              </div>
            }
            placement="bottomLeft"
          >
            <div>
              {" "}
              <b>Ungültiger Dateityp!</b>{" "}
            </div>
          </Tooltip>

          <ul>
            {hasInvalidFiles.length &&
              hasInvalidFiles.map((file, k) => {
                return (
                  <li key={k}>
                    {" "}
                    <b>{file.file.name}</b> {" : " + file.file.type}{" "}
                  </li>
                );
              })}
          </ul>
        </Alert>
      </Snackbar>

      <Accordion
        expanded={expanded === itemId}
        onChange={handleChange(itemId)}
        sx={{
          borderRadius: "4px",
          border: "1px solid #e0e0e0",
          width: "100%",
        }}
      >
        <AccordionSummary
          aria-controls={`${itemId}-content`}
          id={`${itemId}-header-summary`}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="h3" sx={{ color: "#0E3F51" }}>
                {props.item.category} ({attachmentsByCategory.length})
              </Typography>
              <div style={{ marginLeft: "5px" }}>
                {expanded === itemId ? (
                  <ExpandLessRounded
                    color="inherit"
                    style={{ opacity: "0.5" }}
                  />
                ) : (
                  <ExpandMoreRounded
                    color="inherit"
                    style={{ opacity: "0.5" }}
                  />
                )}
              </div>
            </div>
            {/* <MoreVertIcon /> */}
          </div>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            padding: "0px",
          }}
        >
          <div className="dropzone" id={"dropzone-" + itemId}>
            <div className="svg">
              <DropFileSvg />
            </div>
            <div className="title">{i18n.dropzone_dialog_title}</div>
            <input multiple type="file" onChange={handleChangeDropFile} />
          </div>

          <div
            className={"docsDetails-" + itemId}
            style={{
              width: "100%",
              padding: "0% 2%",
              minHeight: attachmentsByCategory.length ? "max-content" : "200px",
            }}
          >
            {loading === "dropzone-" + itemId ? (
              <Skeleton
                variant="rounded"
                width={"100%"}
                height={40}
                animation="wave"
                style={{ margin: "1% 0% 3% 0%" }}
              />
            ) : (
              <>
                {attachmentsByCategory.length > 0 ? (
                  attachmentsByCategory.map((item, key) => {
                    let mimeType = mime.getExtension(
                      item.attachment.file.mimetype
                    );
                    return (
                      <Fragment key={key}>
                        <CardButton
                          pdfUrl={item.attachment.file.url}
                          fileMime={mimeType}
                          file={item.attachment.file}
                          type="internal"
                          fileid={item.attachment.fileid}
                          nodeid={item.attachment.nodeid}
                          fromDragAndDrop
                          // receviedChildValuesInternal={
                          //   receviedChildValuesInternal
                          // }
                          title={
                            item.attachment.title != undefined
                              ? item.attachment.title
                              : "No Title"
                          }
                          description={
                            item.attachment.description != undefined
                              ? item.attachment.description
                              : ""
                          }
                          icon={<PictureAsPdfIcon />}
                          size="large"
                          setAttachmentCategory={props?.setAttachmentCategory}
                          attachmentCategory={item.attachment.specifier}
                        />
                      </Fragment>
                    );
                  })
                ) : (
                  <>
                    <LibraryAddOutlinedIcon
                      sx={{
                        fontSize: 40,
                        opacity: "0.5",
                        width: "24px",
                        height: "24px",
                        mt: 2,
                        mb: 1.2,
                      }}
                    />
                    <Typography variant="h2">
                      Sie haben noch keine Dateien in dieser Kategorie
                      hochgeladen
                    </Typography>
                    <Typography variant="caption" style={{ opacity: 0.5 }}>
                      Laden Sie eine Datei hoch. Tipp: Sie können auch mehrere
                      Dateien <br /> gleichzeitig per Drag und Drop hochladen.
                    </Typography>
                    <br />
                    <Button
                      variant="contained"
                      sx={{
                        marginTop: 2,
                        marginBottom: 4,
                        backgroundColor: "#0E3F51",
                        color: "#fff",
                      }}
                      onClick={() => {
                        props.setAttachmentCategory(props.item.id);
                        props.handleClickOpenInternal();
                      }}
                    >
                      + DATEI HOCHLADEN
                    </Button>
                  </>
                )}
              </>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
});
